<header>
    <div class="header-area header-transparent">
    <div class="main-header ">
    <div class="header-bottom  header-sticky">
    <div class="container-fluid">
    <div class="row align-items-center">
    
    <div class="col-xl-2 col-lg-2">
    <div class="logo">
    <a routerLink="/"><img src="assets/img/logo.png" width="60" alt="aplikasisekolah dan website sekolah"/>Axcora School Apps</a>
    </div>
    </div>
    <div class="col-xl-10 col-lg-10">
    <div class="menu-wrapper  d-flex align-items-center justify-content-end">
    
    <div class="main-menu d-none d-lg-block">
    <nav class="nav fixed-top p-1 shadow"
    style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <ul id="navigation">
    <li class="active"><a href="#">Home</a></li>
    <li><a href="#start">Get Start</a></li>
    <li><a href="#aplikasi">Applikasi</a></li>
    <li><a href="#website">Website</a></li>
    <li><a href="#erp">ERP</a></li>
    <li><a href="#contact">Contact</a></li>
    </ul>
    </nav>
    </div>
    
  
    </div>
    </div>
    
    <div class="col-12">
    <div class="mobile_menu d-block d-lg-none"></div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    </header>
    
  
    
    <div class="slider-area "
        style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <div class="slider-active">
    
    
    <div class="single-slider slider-height" >
    <div class="container">
    <div class="row justify-content-center">
    <div class="col-xl-8 col-lg-11 col-md-12">
    <div class="hero__caption text-center">
    <h1 data-animation="bounceIn" data-delay="0.2s">Axcora School Technology</h1>
    <p data-animation="fadeInUp" data-delay="0.4s">Solusi terbaik dalam kebutuhan <a href="https://axcoraschool.vercel.app">aplikasi sekolah dan website sekolah modern</a> dunia pendidikan dan edukasi.</p>
    <a href="#start" class="btn hero-btn text-white" data-animation="fadeInUp" data-delay="0.7s">Get Started Now</a>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
</div>
    
    <div class="project-screen">
    <div class="container">
    <div class="row">
    <div class="col-lg-12">
    <div class="screen-img text-center">
    <img src="assets/img/aplikasisekolahonline.png" alt="aplikasi sekolah, website sekolah" class="img-fluid w-100"/>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    <div id="start" class="our-services">
    <div class="container">
    <div class="row justify-content-center">
    <div class="col-xl-7 col-lg-8">
    
    <div class="section-tittle text-center mb-80">
    <h2>Website Sekolah dan Aplikasi sekolah all in one</h2>
    <p>Axcora school app technology semakin memberikan kemudahan dalam dunia pendidikan dan edukasi khusus nya sekolah dalam proses belajar mengajar, berbagai aplikasi siap digunakan dalam menunjang kebutuhan sekolah.</p>
    </div>
    </div>
    </div>
    <div class="row text-center">
        <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/websekolah.png" alt="pembuatan website sekolah"/>
    </div>
    <div class="services-cap">
    <h5><a href="https://axcoraschool.vercel.app">Website Sekolah</a></h5>
    <p>Axcora school cms special untk website sekolah apps.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/absensisekolah.png" alt="aplikasi sekolah absensi"/>
    </div>
    <div class="services-cap">
    <h5><a href="https://axcoraschool.vercel.app">Absensi Apps</a></h5>
    <p>Aplikasi absensi online untuk siswa murid dengan simple .</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/media.png" alt="aplikasi belajar online download upload media"/>
    </div>
    <div class="services-cap">
    <h5><a href="https://axcoraschool.vercel.app">E-Learn Media</a></h5>
    <p>Aplikasi elearning dengan fitur upload dan download file.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/tugas.png" alt="aplikasi belajar sekolah"/>
    </div>
    <div class="services-cap">
    <h5><a href="https://axcoraschool.vercel.app">Tugas Apps</a></h5>
    <p>Aplikasi untuk ujian dan tugas online siswa sekolah.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/rapot.png" alt="aplikasi rapot dan penilaian online"/>
    </div>
    <div class="services-cap">
    <h5><a href="https://axcoraschool.vercel.app">Rapot Apps</a></h5>
    <p>aplikasi rapot dan penilaian online yang mudah digunakan.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/pembayaransekolah.png" alt="aplikasi pembayaran uang sekolah dan keuangan sekolah"/>
    </div>
    <div class="services-cap">
    <h5><a href="https://axcoraschool.vercel.app">Keuangan Apps</a></h5>
    <p>aplikasi pembayaran uang sekolah dan keuangan sekolah.</p>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="about-area2 section-padding40 section-bg2" data-background="assets/img/section-bg3.png">
    <div id="aplikasi" class="container">
    <div class="row align-items-center">
    <div class="col-xl-5 col-lg-6 col-md-12">
    <div class="about-caption mb-50">
    <div class="about-icon text-center text-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
            <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
          </svg>
    </div>
    
    <div class="section-tittle mb-25">
    <h2>Applikasi sekolah lengkap.</h2>
    </div>
    <p class="mb-20">
Mudahkan proses belajar mengajar dengan axcora school apps, untuk kebutuhan e-learning, absensi, tugas dan ujian , nilai dan rapot, hingga keuangan sekolah tersedia untuk plugin school web app anda. </p>
    <a routerLink="/aplikasi" class="btn all-btn text-white">Informasi</a>
    </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
    
    <div class="about-img ">
    <img src="assets/img/aplikasilearningsekolah.png" alt="aplikasi sekolah lengkap"/>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="about-area2 pb-bottom">
    <div id="website" class="container">
    <div class="row align-items-center">
    <div class="col-xl-6 col-lg-5 col-md-9">
    
    <div class="about-img ">
    <img src="assets/img/cmssekolah.png" alt="pembuatan website sekolah"/>
    </div>
    </div>
    <div class="col-xl-5 col-lg-6 col-md-12">
    <div class="about-caption mb-50">
        <div class="about-icon text-center text-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.523-3.356c.329-.314.158-.888-.283-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767l-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288l1.847-3.658 1.846 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.564.564 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"/>
          </svg>
    </div>
    
    <div class="section-tittle mb-25">
    <h2>CMS Web Sekolah</h2>
    </div>
    <p class="mb-20">
Sekarang semakin mudah dan cepat dengan axcora school cms sekolah untuk digunakan develope website modern sekolah, konsep dan struktur tema sudah tersedia tinggal edit dan online kan sekolah anda.
    </p>
    <a routerLink="/cms" class="btn all-btn text-white">Informasi</a>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="video-area section-bg2 d-flex align-items-center" style="background-image: url('assets/img/aplikasi sekolah e-slearn online.jpg');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <div id="erp" class="container">
    <div class="video-wrap position-relative">
    
    
    <div class="video-icon">
    <a class="popup-video btn-icon" href="https://www.youtube.com/playlist?list=PLQDm6k9_HvYPvK5GDjK4BJNaxShM3lHR8" target="blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
            <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
          </svg>
    </a>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>ERP Sekolah</h2>
        <p>All in one system web app sekolah dalam satu applikasi super lengkap dalam kebutuhan proses belajar mengajar , e learning, absensi, hingga keuangan sekolah , agenda pengumuman berita sekolah include.
    <br/>
    Applikasi ERP sekolah dengan admin apps, guru pengajar apps, tata usaha dan keuangan apps, siswa murid apps, all in one integrasi dalam axcora school ERP untuk sekolah anda.
        </p>
        <a routerLink="/axcoraschool" class="btn3 wantToWork-btn">Pelajari ERP Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
    
